import React, {useRef} from "react";
import {useFrame, useThree} from "react-three-fiber";
import * as THREE from "three";

import imatges from "./assets/imatges.json"
import categories from "./assets/categories.json"

import Imatge from "./Imatge";

const Imatges = (props) => {
	let base_url = '//' + window.location.hostname + '/wp-content/uploads/';
	if (window.location.hostname === "localhost") {
		base_url = 'http://itineraris/wp-content/uploads/';
	}
	const circle_radius = 20;
	const circle_height = 3;

	const group = useRef();

	const {camera} = useThree()

	useFrame((state) => {
		group.current.children.forEach(function (imatge, index) {
			const d = imatge.position.distanceTo( camera.position );
			if (d > circle_radius) {
				const dist = imatge.position.clone().sub(camera.position);
				imatge.position.add(dist.multiplyScalar(-1.9));
				// TODO: assegurar-se que la nova posició està < dist (hauria, no?)
			}
		});
	});

	const getRandomPosition = () => {
		const radius =  Math.sqrt(Math.random()) * circle_radius;
		const phi = Math.random() * 2 * Math.PI;
		const y = (circle_height / 2) - Math.random() * circle_height;
		return new THREE.Vector3().setFromCylindricalCoords(radius, phi, y).add(camera.position);
	}

	const images = React.useMemo(() =>
		imatges.map(item => ({
			...item,
			position: getRandomPosition()
		})), [imatges]
	)

	const lang = (typeof window.lang === 'undefined' || window.lang === '' ? 'ca' : window.lang);

	return (
		<group ref={group}>
			{images.map(function (imatge, index) {

				const position = imatge.position;
				const link = imatge.post[lang] + '#' + imatge.anchor;
				const pagina = categories[imatge.pagina][lang];

				return <Imatge
					key={index}
					position={position}
					src={base_url + imatge.url}
					link={link}
					ratio={imatge.ratio}
					pagina={pagina}
					radius={circle_radius}
				/>;
			})}
		</group>
	);
}
export default Imatges;